import React, { Fragment } from 'react';
import { Col, Row } from 'reactstrap';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ArcaComponent } from '../../pages/ArcaComponent';

export class PageDetailsPanel extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    tidyup(str) {
        str = str.toLowerCase()
            .replace(' ', '')
            .replace('(', '')
            .replace(')', '');
        return str;
    }

    render() {
        let { details, index } = this.props

        let title = <Fragment>
            {details.Title
                ? <h1 style={{ paddingLeft: '30px' }} id={this.tidyup(details.Title)}>{details.Title}</h1>
                : null}
        </Fragment>

        let text = <Fragment>
            {details.Preamble
                ? <strong style={{ paddingLeft: '30px' }}>{details.Preamble}</strong>
                : null}
            {details.Description
                ? <Fragment>{details.Description.split('/n').map((d, k) => <p key={k} style={{ margin: '30px' }} >{d}</p>)}</Fragment>
                : null}
        </Fragment>

        let image =
            details.Photo
                ? <img src={ArcaHttpSystem.PhotoFolder + 'Photos/' + details.Photo + `.jpg`} width='100%' />
                : null

        let imageColWidth = image ? '6' : '4';
        let textColWidth = image ? '6' : '8';

        return (
            <Fragment>
                <div id={details.Tag}>
                    {ArcaHttpSystem.IsSmartphone
                        ? <Fragment>
                            <Col>
                                {title}
                                {image}
                                {text}
                            </Col>
                        </Fragment>

                        : <Row>
                            {index === 0
                                ? <span />
                                : details.PhotoPosition === 'Left'
                                    ? <Fragment>
                                        <Col xs={imageColWidth}>
                                            {image ? image : title}
                                        </Col>
                                        <Col xs={textColWidth}>
                                            {image ? title : image}
                                            {text}
                                        </Col>
                                    </Fragment>
                                    : details.PhotoPosition === 'Right'
                                        ? <Fragment>
                                            <Col xs={textColWidth} style={{ paddingLeft: '40px' }}>
                                                {image ? title : image}
                                                {text}
                                            </Col>
                                            <Col xs={imageColWidth}>
                                                {image ? image : title}
                                            </Col>
                                        </Fragment>
                                        : details.PhotoPosition === 'Top'
                                            ? < Fragment >
                                                <Col xs='12'>
                                                    {title}
                                                    {image}
                                                    {text}
                                                </Col>
                                            </Fragment>
                                            : <Fragment>
                                                <Col xs='12'>
                                                    {title}
                                                    {text}
                                                    {image}
                                                </Col>
                                            </Fragment>
                            }
                        </Row>
                    }
                </div>
            </Fragment>);
    }
}